import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './gisSider.less';
import Input from 'src/types/iview/Input';
import Icon from 'src/types/iview/Icon';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import StationListApi, { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import EnumStationType from 'src/enums/enumStationType';
import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
import StationListService from 'src/pages/stationList/service/stationListService';
import StationTree from 'src/components/stationTree/stationTree';
import StationTreeUtils from 'src/components/stationTree/stationTreeUtils';
import Bus, { Events } from 'src/util/bus';
let bem = createBEM('gis-sider');

@Component
export default class GisSider extends Vue.Component<any> {
    // 是否带啊污染源站点列表
    contaminate: boolean = true;
    // 是否打开地表水站点
    surface: boolean = true;
    // 是否打开地下水
    undergroundWater:boolean = true;
    stationName: string = '';
    waterList: StationListDOI.RowDataI[] = [];
    pollutionList: StationListDOI.RowDataI[] = [];
    undergroundWaterList: StationListDOI.RowDataI[] = [];
    stationType = '区域'
    expand: boolean = false
    
    get waterTree() {
        if(this.stationType === '区域') {
            return StationTreeUtils.getAreaStationTree(this.waterList,this.expand,this.expand,this.expand)
        } else {
            return StationTreeUtils.getBasinStationTree(this.waterList,this.expand)
        }
    }

    get pollutionTree() {
        if(this.stationType === '区域') {
            return StationTreeUtils.getAreaStationTree(this.pollutionList,this.expand,this.expand,this.expand)
        }else {
            return StationTreeUtils.getBasinStationTree(this.pollutionList,this.expand)
        }
    }

    get undergroundWaterTree()
    {
        if(this.stationType === '区域') {
            return StationTreeUtils.getAreaStationTree(this.undergroundWaterList,this.expand,this.expand,this.expand)
        }else {
            return StationTreeUtils.getBasinStationTree(this.undergroundWaterList,this.expand)
        }
    }
    async search() {
        let waterList: StationListDOI.RowDataI[] = [];
        let pollutionList: StationListDOI.RowDataI[] = [];
        let undergroundWaterList: StationListDOI.RowDataI[] = [];
        let { data, code } = await StationListApi.searchDeviceList({ device_name: this.stationName });
        if (code === 0) {
            this.expand = !!this.stationName
            data.data_info.forEach(i => {
                i.type === EnumStationType.Pollution.getId() ? pollutionList.push(i) : i.type === EnumStationType.Water.getId() ? waterList.push(i)
                :undergroundWaterList.push(i);
            });
            this.waterList = waterList;
            this.pollutionList = pollutionList;
            this.undergroundWaterList = undergroundWaterList;
            return data.data_info;
        }
        return []
    }
    clickStation(data) {
        StationListService.goToStationDetail(data.type, data)
    }
    locationStation(data) {
        Bus.$emit(Events.GISStationClick, data)
    }
    async mounted() {
        let data = await this.search();
        this.$emit('init', data);
    }
    
    renderRow(h, i: StationListDOI.RowDataI) {
        return (
            <row class={bem('list-item')} gutter={10} key={i.mn}>
                <div onClick={this.clickStation.bind(this, i)}>
                    <i-col span="12"><span title={i.name}>{i.name}</span></i-col>
                    <i-col span="12">
                        岸边站监测：<span
                            class={bem('list-tag', {
                                malfunction: i.device_status === EnumDeviceStatus.Malfunction.getId(),
                                offline: i.device_status === EnumDeviceStatus.Offline.getId(),
                            })}
                        >
                            {EnumDeviceStatus.findId(i.device_status).getName()}
                        </span>
                    </i-col>
                    <i-col span="12"><span  title={i.province_name + i.city_name + i.district_name}>区域：{i.province_name + i.city_name + i.district_name}</span></i-col>
                    <i-col span="12">{i.basin}</i-col>
                    <div class="text-center">
                        <img src={require('../../../assets/images/list-split.png')} alt="" />
                    </div>
                </div>
            </row>
        );
    }
    render(h) {
        return (
            <FrameSideBg style="height: 100%">
                <div class={bem()}>
                    <div class={bem('search-input')}>
                        <Input
                            
                            icon="ios-search"
                            placeholder="监测点名称"
                            style="width: auto"
                            v-model={this.stationName}
                            on-on-click={this.search.bind(this)}
                            on-on-keypress={e => {
                                e.keyCode === 13 && this.search();
                            }}
                        />
                        <div class={bem('search-clear')} on-click={()=> {
                            this.stationName = '';
                            this.search()
                        }}>重置</div>
                    </div>
                    <div class={bem('title')} onClick={() => {}}>
                        <span>站点列表</span>
                        <div class="float-right"  >
                            <div class={bem('station-type', {active: this.stationType==='区域'})} on-click={()=> this.stationType='区域'}>区域</div>
                            <div class={bem('station-type', {active: this.stationType==='流域'})} on-click={()=> this.stationType='流域'}>流域</div>
                        </div>
                    </div>
                    <div class={bem('station-list')}>
                        <div class={bem('station-title')} onClick={() => (this.contaminate = !this.contaminate)}>
                            污染源站点
                            <Icon v-if={this.contaminate} type="ios-arrow-down" />
                            <Icon v-else type="ios-arrow-forward" />
                        </div>
                        <StationTree
                            v-show={this.contaminate}
                            ref="stationTree"
                            dataSource={this.pollutionTree}
                            on-click={this.locationStation.bind(this)}
                        />
                        {/* {this.contaminate && (
                            <div>
                                {this.pollutionList.map(i => {
                                    return this.renderRow(h, i);
                                })}
                            </div>
                        )} */}
                        <div class={bem('station-title')} onClick={() => (this.surface = !this.surface)}>
                            地表水站点
                            <Icon v-if={this.surface} type="ios-arrow-down" />
                            <Icon v-else type="ios-arrow-forward" />
                        </div>
                        <StationTree
                            v-show={this.surface}
                            ref="stationTree"
                            dataSource={this.waterTree}
                            on-click={this.locationStation.bind(this)}
                        />
                        {/* {this.surface && (
                            <div>
                                {this.waterList.map(i => {
                                    return this.renderRow(h, i);
                                })}
                            </div>
                        )} */}
                        <div class={bem('station-title')} onClick={() => (this.undergroundWater = !this.undergroundWater)}>
                            地下水站点
                            <Icon v-if={this.undergroundWater} type="ios-arrow-down" />
                            <Icon v-else type="ios-arrow-forward" />
                        </div>
                        <StationTree
                            v-show={this.undergroundWater}
                            ref="stationTree"
                            dataSource={this.undergroundWaterTree}
                            on-click={this.locationStation.bind(this)}
                        />
                    </div>
                </div>
            </FrameSideBg>
        );
    }
}
